const module = { name: 'person/overview/photos/desktop.app', exports: {} }; const exports = module.exports;



import { Fandango_debugLog as debugLog } from 'require-core';



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { mps as mps_AdTypes_onLoad_onMPSReady } from 'require-global';

const { AdTypes, onLoad: onMPSReady } = mps_AdTypes_onLoad_onMPSReady;


import { default as gallery } from 'swug-fdRequire-call:photos/gallery/shared';



import { default as share } from 'swug-fdRequire-call:Fandango/share';



import { default as hearts } from 'swug-fdRequire-call:shared/utils/hearts';



import { Fandango_carousel as fdCarousel } from 'require-global';

function run() {
    checkDependencies(module.name, debugLog);
    share.filterNetworks([
        'facebook',
        'twitter'
    ]);
    gallery.init({ share });
    hearts.init();
    gallery.run();
}
run();
export default module.exports;